import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import SelectedElementsLayerMobile from './selected-element-layer/selected-elements-layer-mobile';
import CursorBorderMobile from './components/cursor-border/cursor-border-mobile';
import ConnectElementsMobile from './components/connected-elements/connected-elements-mobile';
import ErrorBoundary from '@com/error-boundary';
import { SnapLines } from '@src/slide/application/service/snap-line-service/render/snap-line';
import { ServicesContext } from '@editor/src/page/index/components/canvas/edit-panel/context';
import { mobileSnapLineStyleSheet } from '@src/slide/application/service/snap-line-service/render/style-sheet';

interface IEditPanelMobileProps {
    scale: number;
}

/**
 * 选中框等编辑外框都放到这个面板上面，面板上按照元素顺序来渲染每个元素的编辑外框
 */
export default class EditPanelMobile extends React.Component<IEditPanelMobileProps> {
    static contextType = ServicesContext;

    public shouldComponentUpdate(nextProps: IEditPanelMobileProps): boolean {
        if (nextProps.scale !== this.props.scale) {
            return true;
        }
        return false;
    }


    public render() {
        return (
            <div
                id={'edit-panel'}
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    zIndex: 1,
                    pointerEvents: 'none',
                }}
            >
                <SelectedElementsLayerMobile
                    scale={this.props.scale}
                />
                <ConnectElementsMobile
                    scale={this.props.scale}
                />
                <CursorBorderMobile
                    scale={this.props.scale}
                />
                {
                    <ErrorBoundary>
                        <Suspense fallback={<div/>}>
                            <SnapLines
                                scale={{ frameScale: this.props.scale, graphicScale: 1 }}
                                snapLineService={this.context.snapLineService}
                                styleSheet={mobileSnapLineStyleSheet}
                            />
                        </Suspense>
                    </ErrorBoundary>
                }
            </div>
        );
    }
}
